module.exports = {
    header: {
        dates: {
            date: 'SEPTEMBER 2021',
            place: 'MOSCOW VNUKOVO-3',
        },
        slogan: `Do not miss<br/>the key business<br/>aviation event <span>RUBAE</span>`,
        button: 'Become an exhibitor',
        registrationButton: 'Buy a ticket',
        saleMessage: 'Save up to 15% on booking till 31 May',
        countDown: {
            text: 'STARTS IN ',
            day: ' d.',
            cancelText: 'Exhibition canceled.',
        },
    },
    about: {
        visitors: 'More than 10000 visitors',
        aircrafts: 'More than 20 aircrafts and helicopters',
        conference: 'New conference programm',
        about: 'More about exhibition',
        marketing: 'Marketing opportunities',
        navigation: {
            exhibitors: {
                title: 'Exhibitors',
                description: `Become an exhibitor and get maximum opportunities
            representing your company at a unique industry event
            in Russia and CIS.`,
            },
            attendee: {
                title: 'Attendee',
                description: `Stay up to date with the latest industry trends and
            promote your business with RUBAE.`,
            },
            opportunities: {
                title: 'Additional opportunities',
                description: `Make your stay at the exhibition more convenient and efficient.`,
            },
            registration: {
                title: ' ',
                description: `Aircraft registration with Bermuda.`,
            },
        },
    },
    exhibitors: {
        exhibitors: {
            title: 'Exhibitors',
            buttonTitle: 'Become an exhibitor',
            text: 'The RUBAE2021 exhibit application is now available.',
            links: {
                'exhibitor-manual': 'Exhibitor Manual',
                'pages/general-contractor': 'General contractor',
                'pages/freight-forwarder': 'Official freight forwarder',
                'pages/catering-partner': 'Official catering partner',
                'pages/visa-support': 'Visa support',
            },
            personalAccountButton: 'Personal account',
        },
        attendee: {
            title: 'Attendee',
            buttonTitle: 'Buy a ticket',
            text:
                'Center of business aviation Vnukovo-3 invites to visit the only business aviation event  in Russia and CIS countries from 8 September till 10 September 2021.',
            links: {
                'pages/about': 'General information',
                'pages/location': 'Location',
                'pages/exhibitor-list': 'Exhibitor list',
                pavilion_exposition: 'Pavilion exposition',
            },
        },
    },
    sponsors: 'Partners',
    participants: 'With the participation of',
    'info-sponsors': 'Information support',
    advertisement: 'Оther advertising',
    contacts: {
        title: 'Contact us',
        legalInfo: '',
        confidention: '',
    },
    contactForm: {
        name: 'Company name',
        contactPerson: 'Contact person',
        tel: 'Tel',
        email: 'E-mail',
        address: 'Address',
        website: 'Website',
        promo: 'Promo code',
        boothNumber: 'Booth number',
        stand: 'Stand',
        static: 'Static',
        submit: 'Submit',
        formatLabel: 'Participation format',
        successMessage: 'Thank you! We will contact you.',
        errorMessage: 'Something went wrong. Try again later.',
    },
    conferenceProgramForm: {
        formTitle: 'APPLICATION FOR PARTICIPATION IN THE BUSINESS PROGRAM',
        name: 'Full name',
        company: 'Company',
        email: 'E-mail',
        subject: 'Topic to discuss',
        successMessage: 'Thank you! We will contact you.',
        errorMessage: 'Something went wrong. Try again later.',
    },
    exhibitApplication: {
        applicationTypeButton: 'Choose type of participation',
        valuePlaceholder: 'Enter value',
        services: {
            shellScheme: {
                title: 'Shell Scheme (min. 6㎡)',
                description:
                    'SHELL SCHEME PACKAGE includes: exhibit space, wall panels, carpeting, 1 electrical socket, 1 desk, 2 chairs, 1 lamp, 1 fascia board, liability insurance, company profile in the official RUBAE catalogue. The building of the stand is carried out by the RUBAE Official Contractor Company',
            },
            spaceOnly: {
                title: 'Space Only (min. 18㎡)',
                description:
                    'SPACE ONLY includes: liability insurance, company profile in the official RUBAE catalogue. The building and design of the stand is carried out in accordance with the rules and requirements of the exhibitor manual.',
            },
            staticDisplayChalet3: {
                title: 'Static Display Chalet (3×3)',
                description:
                    'CHALET includes: fascia, 1 electrical socket, floor with carpeting.',
            },
            staticDisplayChalet6: {
                title: 'Static Display Chalet (6×6)',
                description:
                    'CHALET includes: fascia, 1 electrical socket, floor with carpeting.',
            },
            brokerProject: {
                title: 'Broker project',
                description:
                    'WORKING DESK includes: carpeting, 1 electrical socket, 1 branded desk, 1 chair, 1 banner 1.0 x 2.5 meter, liability insurance, company profile in the official RUBAE catalogue, access to broker lounge. The building of the stand is carried out by the RUBAE Official Contractor Company.',
            },
            firstTimeExhibitor: {
                title: 'First Time Exhibitor',
                description:
                    'WORKING DESK includes: carpeting, 1 electrical socket, 1 branded desk, 2 chairs, 1 banner 1.0 x 2.5 meter, liability insurance, company profile in the official RUBAE catalogue, 4 badges. The building of the stand is carried out by the RUBAE Official Contractor Company.',
            },
            upperDeck: {
                title: 'Upper Deck (double storey - space only)',
            },
            wallBrandingChalet3: {
                title: 'Wall branding chalet (for chalet 3×3)',
            },
            wallBrandingChalet5: {
                title: 'Wall branding chalet (for chalet 6×6)',
            },
            catalogueAdPage05: { title: '1/2 Page, full-colour' },
            catalogueAdPage1: { title: '1/1 Page, full-colour' },
            staticDisplay: {
                title: 'Static display',
                description: 'Static display',
                length: 'Aircraft length',
                wingspan: 'Wingspan',
            },
        },
        units: {
            sqrm: '㎡',
            unit: 'unit',
            m: 'm',
        },
        addButton: 'Add participation',
        catalogueAd: 'RUBAE Catalogue AD Rates',
        total: 'Total cost from',
        formTitle: 'Application form',
        contactsTitle: 'Contacts',
        contactsSubtitle: '(all fields are required)',
        allocationTitle: 'Participation',
        comment:
            'This application is the basis for the contract and invoice, which should be paid in the amount of 50% within 10 days after the invoice date. Another 50% should be paid till 31 July 2021. Please note that 50% deposit is not refundable in case of cancellation of the company to participate in the exhibition.',
    },
    pages: {
        schedule: {
            about: 'About',
            registration: 'Registration',
            preview: 'Preview',
            schedule: 'Conference program',
            scheduleLink: 'Download conference program of the RUBAE Show',
        },
        exhibitors: {
            filterDefault: 'Category',
            filterAll: 'All',
        },
    },
    gallery: 'Gallery',
    scheduleWidget: {
        dates: 'September 2021',
        address: 'Center of business aviation Vnukovo-3, Moscow, Russia',
        date1: 'Wednesday, 8 September',
        date2: 'Thursday, 9 September',
        date3: 'Fiday, 10 September',
        covid19: 'COVID-19 safety rules',
        covid19Link: '/files/COVID-19_eng.pdf',
    },
};



// WEBPACK FOOTER //
// ./src/data/messages/en.js